import React, { useRef , useState, useContext, useEffect} from 'react';
import { Button, Col, ConfigProvider, Modal, Row, Typography, Card,Image, Divider} from 'antd';
import Colors from "../../../../styles/Colors";
import { BiArrowToBottom } from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import Rebut from '../../../../model/multilleure/rebuts/Rebut';
import { useReactToPrint } from 'react-to-print';
import logo from '../../../../images/Artiesportslogo.jpeg';
import { GetRebutsProductes } from '../../../../dao/multilleure/GetRebutsProductes';
import Producte from '../../../../model/multilleure/rebuts/Producte';
import {AuthContext} from "../../../../config/AuthContext";

const { Title, Text } = Typography;

interface FacturaModalProps {
    element: Rebut | undefined | any;
    visible: boolean;
    onClose: (value: boolean) => void;
}

const FacturaModal: React.FC<FacturaModalProps> = ({ element, visible, onClose }) => {
    const printRef = useRef<HTMLDivElement>(null);
    const [producte, setProducte] = useState<Producte[]>([]);

    const handleCancel = () => onClose(false);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    const handleDownloadPDF = useReactToPrint({
        content: (() => printRef.current) as () => HTMLElement,
    });

    async function checkDades() {
        const dades = await GetRebutsProductes(page, element.id);
        setProducte(dades ?? []);
    }
    useEffect(() => {
        if (visible && element?.id) {
            checkDades();
        }
    }, [visible, element]);

    return (
        <ConfigProvider locale={locale}>
            <Modal
                open={visible}
                onCancel={handleCancel}
                footer={null}
                width={900}
                style={{ top: 20 }}
            >
                <div ref={printRef} style={{ padding: 40 }}>
                    <Card bordered>
                        <Row justify="space-between" align="top">
                            <Col span={8}>
                                <Title level={5} style={{ marginBottom: 8 }}>ART i ESPORT Badalona</Title>
                                <Text>Via Augusta, 43 local 1</Text><br />
                                <Text>08911 Badalona</Text><br />
                                <Text>G67502534</Text>
                            </Col>
                            <Col span={6}>
                                <Text><strong>Rebut número:</strong></Text><br />
                                <Text style={{backgroundColor:'#fffed9', padding:'4px'}}>{element?.id}</Text>
                            </Col>
                            <Col span={6}>
                                <Text><strong>Data d'expedició:</strong></Text><br />
                                <Text style={{backgroundColor:'#fffed9', padding:'4px'}}>
                                {element?.alta
                                    ? new Date(element.alta).toLocaleDateString('es-ES')
                                    : ''}
                                </Text><br /><br />
                            </Col>
                            <Col span={4}>
                                <Image width={130} src={logo} preview={false} />
                            </Col>
                        </Row>

                        <Divider />
                          
                            <Row style={{marginBottom:"10px"}}>
                                <Col  flex="130px">Hem rebut de: </Col>
                                <Col flex="auto" ><Text style={{backgroundColor:'#fffed9', padding:'5px'}}>{element?.pagador}</Text></Col>
                            </Row>
                            

                            <Row style={{marginBottom:"10px"}}>
                                <Col flex="130px">L'import de: </Col>
                                <Col flex="auto" > <Text style={{backgroundColor:'#fffed9', padding:'5px', width:'100%'}}><strong>{element?.pagat}€</strong></Text></Col>
                            </Row>
                        
                            <Row style={{marginBottom:"10px"}}>
                                <Col flex="130px">En concepte de:</Col>
                                <Col flex="auto" > <Text style={{backgroundColor:'#fffed9', padding:'5px'}}>{element?.concepte}</Text> </Col>
                            </Row>

                           
                            <Row >
                                <Col flex="130px">Resum:</Col>
                                <Col flex="auto">
                                    <div style={{ backgroundColor: '#fffed9', padding: '5px' }}>
                                        {Array.isArray(producte) && producte.length > 0 ? (
                                            producte.map((prod, index) => (
                                                <div key={index}>
                                                    <Text>- {prod.descripcio}</Text>
                                                </div>
                                            ))
                                        ) : (
                                            <Text>No hi ha resumen.</Text>
                                        )}
                                    </div>
                                </Col>

                            </Row>
                                
                        
                        
                    </Card>
                </div>
                <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                    <Col>
                        <Button
                            icon={<BiArrowToBottom />}
                            style={{ backgroundColor: Colors.colors.color6 }}
                            onClick={handleDownloadPDF}
                        >
                            Imprimir/Descarregar PDF
                        </Button>
                    </Col>
                </Row>
            </Modal>
        </ConfigProvider>
    );
};

export default FacturaModal;
